import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { IUEvent } from '../../lib/event';
import { useUserContext } from '../../contexts/UserContext';

import sunshinePhotosPng from 'Common/src/assets/ShineIcon.svg';
import { ULogApplication, ULogSeverity, ULogTag, logSumoEvent } from 'Common/src/api/SumoLogicApi';

import { TElkAlbumJoinStatus } from 'TProtocol/prototypes/events/messages';

const PhotosLink = ({ event }: { event: IUEvent }) => {
  const userContext = useUserContext();
  const albumDetails = event.albumDetails;

  const onLinkClick = () => {
    void logSumoEvent({
      app: ULogApplication.ELK,
      severity: ULogSeverity.INFO,
      userId: userContext.id,
      tag: ULogTag.UserAction,
      message: '[PhotosLink] Clicked on photos link'
    });
  };

  if (albumDetails === undefined) {
    return null;
  }

  let message: ReactNode;
  if (albumDetails.albumJoinStatus === TElkAlbumJoinStatus.NOT_JOINED) {
    message = 'Share event photos through the app!';
  } else {
    message = 'View the album in the Shine app';
  }

  let codeContents: ReactNode = null;
  if (albumDetails.albumCode !== undefined) {
    codeContents = <div>
      Event code: <strong>{albumDetails.albumCode}</strong>
    </div>;
  }

  if (albumDetails.albumUrl !== undefined) {
    return <AlbumLink href={`https://${albumDetails.albumUrl}`} target="_blank" rel="noreferrer" onClick={onLinkClick}>
      <IconImg src={sunshinePhotosPng}/>
      <div>
      {message}
      {codeContents}
      </div>
    </AlbumLink>;
  } else {
    return <ContentsContainer>
      <IconImg src={sunshinePhotosPng}/>
      <div>
      {message}
      {codeContents}
      </div>
    </ContentsContainer>;
  }
};

const IconImg = styled.img`
  width: 65px;
  min-width: 65px;
  height: 65px;
  border-radius: 22%;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
`;

const ContentsContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

const AlbumLink = styled.a`
  text-decoration: none;
  color: currentColor;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

export default PhotosLink;
